import React, { useState, useEffect } from "react";
import Modals from "@/YSComponents/Modals";
import { Button, Image, Form, Input } from "@arco-design/web-react";
import './index.less'
import { CommModalProps } from '@/enum'
const FormModal = (props: CommModalProps) => {
  const { title, visible, width = 486, handCancel, submitHandle, children, icon, showFooter = true, loading = false, subTitle = '确定'  } = props;
  return (
    <Modals
      width={width}
      title={title}
      showFooter={showFooter}
      handleCancel={() => { handCancel(!visible) }}
      cancelBtn={
        <Button
          style={{ marginRight: '10px' }}
          onClick={
            () => {
              if (handCancel) handCancel(!visible);
            }
          }>
          取消
        </Button>
      }
      subMiteBtn={
        <Button
          loading={loading}
          type="primary"
          onClick={() => {
            submitHandle();
          }}>
          {subTitle}
        </Button>
      }
      titleIcon={
        icon && <Image style={{ marginRight: '17px' }} width={18} preview={false} src={icon} />
      }
      visible={visible}>
      { children }
    </Modals>
  );
}

export default FormModal;
